App.controller('LifeSummaryCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', 'lifeInsuranceService', '$window', 'FileSaver', '$q', '$timeout', function ($scope, $sce, $state, $http, packageService, $stateParams, lifeInsuranceService, $window, FileSaver, $q, $timeout) {
    $scope.stateParams = $stateParams;

    // $scope.page = 'life';
    // $scope.$emit('page', $scope.page);

    $scope.page = 'zoch_report';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Podsumowanie'; 
    $scope.$emit('step', $scope.step);

    $scope.link = '';
    $scope.$emit('link', $scope.link);

    if ($scope.stateParams.summary) {
        $scope.summary = $scope.stateParams.summary;
    } else {
        $state.go('root.life.start');
    }

    $scope.packagesInfoForDeclarations = {};

    if ($scope.stateParams.saveResponse && $scope.stateParams.saveResponse.declarations) {
        $scope.declarations = $scope.stateParams.saveResponse.declarations; 
        $scope.ids = getIds();
    } else {
        $state.go('root.life.start');
    }

    $q.all([packageService.dataLifeList()]).then(function (responses) {
        (function () {
            lifePackagesCallback(responses[0]);
            assignPackagesInfoToDeclarations();
        })();
    });

    function getIds() {
        var ids = [];
        angular.forEach($scope.declarations, function (singleDeclaration, declarationKey) {
            ids.push(singleDeclaration.uuid);
        });

        return ids;
    }

    function lifePackagesCallback(data) {
        $scope.lifePackages = data.data.group;
    }

    function assignPackagesInfoToDeclarations() {
        angular.forEach($scope.declarations, function (singleDeclaration, declarationKey) {
            if (typeof $scope.packagesInfoForDeclarations[declarationKey] !== "undefined") {
                return;
            }
            if(!singleDeclaration['lifeInsurance']){
                $scope.packagesInfoForDeclarations[declarationKey] = {
                    title: '',
                    price: '',
                };
                return;
            }
            angular.forEach($scope.lifePackages, function (singleGroup) {
                console.log(singleGroup);
                angular.forEach(singleGroup.item, function (singlePackage) {
                    if (singlePackage.id === singleDeclaration['lifeInsurance'].id) {
                        $scope.packagesInfoForDeclarations[declarationKey] = {
                            title: singleGroup.name + ' ' + singlePackage.name,
                            price: singlePackage.price
                        };
                    }
                });
            });
        })
    }

    $scope.downloadAllDeclarations = function (ev) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        var data = {
            uuids: $scope.ids
        }
        lifeInsuranceService.getDeclarationsSelectedFile(data).then(function (response) {
            if (response.status === 200) {
                var data = new Blob([response.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'deklaracja.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    $scope.downloadDeclaration = function (ev, declaration) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        var id = declaration.uuid,
            barcode = declaration.barcode;

        lifeInsuranceService.getDeclarationFile(id).then(function (response) {
            if (response.status === 200) {
                var data = new Blob([response.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'Deklaracja_' + barcode +'.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };
}]);
